(function() { window.GUID_8943d300_35fe_4b1c_8e5c_f74d669c3695 = { getGuid: function() { return "8943d300-35fe-4b1c-8e5c-f74d669c3695"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        var VideoPlayerInternals;
        (function (VideoPlayerInternals) {
            class Thumbnail {
                _onLoaded() {
                    if (this.loadedCallbacks.length > 0)
                        for (var i = 0; i < this.loadedCallbacks.length; i++) {
                            this.loadedCallbacks[i]();
                        }
                }
                get onLoaded() {
                    return () => { };
                }
                set onLoaded(callback) {
                    this.loadedCallbacks.push(callback);
                }
                get Loaded() { return this.loaded; }
                constructor(videoUrl, onError) {
                    this.videoUrl = videoUrl;
                    this.loaded = false;
                    this.loadedCallbacks = new Array();
                    this.seekingQueue = new Array();
                    this.seekingTimeout = -1;
                    this.video = document.createElement('video');
                    this.video.onerror = (e) => {
                        if (onError)
                            onError(e);
                    };
                    this.video.onloadedmetadata = () => {
                        this.loaded = true;
                        this._onLoaded();
                    };
                    this.video.src = videoUrl;
                }
                Dispose() {
                    this.video.onloadedmetadata = null;
                    this.clearSeekingTimeout();
                    this.seekingQueue = null;
                    this.loaded = false;
                    this.video.remove();
                }
                queue(callback) {
                    this.seekingQueue.push(callback);
                }
                deQueue() {
                    if (this.seekingQueue.length > 0)
                        return this.seekingQueue.shift();
                    return () => { };
                }
                getImageFinished() {
                    this.clearSeekingTimeout();
                    if (this.seekingQueue.length > 0)
                        this.deQueue()();
                }
                clearSeekingTimeout() {
                    if (this.seekingTimeout != -1) {
                        clearTimeout(this.seekingTimeout);
                        this.seekingTimeout = -1;
                    }
                }
                setSeekingTimeout(onseeked) {
                    this.seekingTimeout = window.setTimeout(() => {
                        this.video.removeEventListener("seeked", onseeked);
                        this.getImageFinished();
                    }, 1000);
                }
                GetImage(seconds, callback, maxSize) {
                    if (this.seekingTimeout != -1)
                        return this.queue(() => { this.GetImage(seconds, callback, maxSize); });
                    var onseeked = (e) => {
                        var canvas = document.createElement('canvas');
                        if (maxSize) {
                            var ratio = 1;
                            if (maxSize.Width && this.video.videoWidth > maxSize.Width)
                                ratio = maxSize.Width / this.video.videoWidth;
                            else if (!maxSize.Width || this.video.videoHeight > maxSize.Height)
                                ratio = maxSize.Height / this.video.videoHeight;
                            canvas.width = this.video.videoWidth * ratio;
                            canvas.height = this.video.videoHeight * ratio;
                            var ctx = canvas.getContext('2d');
                            ctx.drawImage(this.video, 0, 0, canvas.width, canvas.height);
                        }
                        else {
                            canvas.height = this.video.videoHeight;
                            canvas.width = this.video.videoWidth;
                            var ctx2 = canvas.getContext('2d');
                            ctx2.drawImage(this.video, 0, 0, canvas.width, canvas.height);
                        }
                        callback.call(this, canvas.toDataURL());
                        this.video.removeEventListener("seeked", onseeked);
                        this.getImageFinished();
                    };
                    this.setSeekingTimeout(onseeked);
                    this.video.addEventListener("seeked", onseeked);
                    var secs = null;
                    if ('function' === typeof seconds)
                        secs = seconds();
                    else
                        secs = seconds;
                    this.video.currentTime = Math.min(Math.max(0, (secs < 0 ? this.video.duration : 0) + secs), this.video.duration);
                }
            }
            VideoPlayerInternals.Thumbnail = Thumbnail;
        })(VideoPlayerInternals = Controls.VideoPlayerInternals || (Controls.VideoPlayerInternals = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=VideoPlayer.Thumbnail.pre.js.map
